// eslint-disable-next-line import/prefer-default-export
export const CREATE_CREATIVE_ERRORS = {
    422003: 'Offer not supported iframe', // ru,en
    422005: 'Placement for offerId not found!', // ru,en
    422006: "Link doesn't supported by offer regexp", // ru,en
    422009: 'Placement for offerId not found!', // ru,en
    422010: 'Link must be a valid URL', // ru,en
    422014: 'Offer is required', // ru,en
    422028: 'Placement is required', // ru,en
    422029: 'Placement is not allowed', // ru,en
    422030: 'Offer does not match placement', // ru,en
    422031: 'Description must be a maximum of 100 characters', // ru,en
    422002: 'RefOfferId error!',
    422004: 'Offer not found!',
    422007: 'Banners list error!',
    422008: "Offer param 'link_default' is empty!",
    422011: 'Description must be a string.',
    422012: 'Type must be a string.',
    422013: 'Required field', // ru,en
    422015: 'OfferId must be a number.',
    422016: 'Link error!',
    422017: 'Size value error!',
    422018: 'Banners value error!',
    422019: 'RefOfferId value error!',
    422020: 'AttractToCashback value error!',
    422022: 'Required field', // ru,en
    422023: 'RefOfferId must be a number.',
    422024: 'Banners must be an array.',
    422025: 'AttractToCashback must be a string.',
    422032: 'Description must be a maximum of 100.',
    422035: 'Required field', // ru,en
    422036: 'OrdText must be a maximum of 65000 characters.',
    422037: 'Required field', // ru,en
    422038: 'ordRim must be a format: JPG, JPEG, PNG, HEIC, HEIF and have a maximum file size of 10 MB', // ru,en
    422039: 'Required field', // ru,en
    422040: 'OrdDescription must contain special characters (?!*$), space, numbers and be 1 to 1000 characters long.', // ru,en
    422041: 'OrdForm invalid. Allowed values: banner, text, textGraphic, other',
    422042: 'Maximum number of characters {{length}}',
    422046: 'Cannot advertise due to AliExpress policy',
    422054: 'No products found matching the link',
    default: 'Something went wrong',
};

export const INPUT_NAMES_BY_CREATIVE_ERROR = {
    422003: 'offer',
    422005: 'placement',
    422006: 'link',
    422009: 'placement',
    422010: 'link',
    422014: 'offer',
    422028: 'placement',
    422029: 'placement',
    422030: 'placement',
    422031: 'name',
    422002: 'refOfferId',
    422004: 'offerId',
    422007: 'banners',
    422011: 'description',
    422012: 'type',
    422013: 'type',
    422015: 'offerId',
    422016: 'link',
    422017: 'size',
    422018: 'banners',
    422019: 'refOfferId',
    422020: 'attractToCashback',
    422022: 'description',
    422023: 'refOfferId',
    422024: 'banners',
    422025: 'attractToCashback',
    422032: 'description',
    422035: 'ordText',
    422036: 'ordText',
    422037: 'ordRim',
    422038: 'ordRim',
    422039: 'ordDescription',
    422040: 'ordDescription',
    422041: 'ordForm',
    422046: 'link',
    422054: 'link',
};
